import { Tab, Tabs } from "@nextui-org/react";
import RequestList from "./requestList/requestList";

const HelpCenterTabs = () => {
  return (
    <div className="flex flex-col justify-start">
      <div className="mb-4 justify-between sm:mb-0 sm:mr-4">
        <Tabs
          classNames={{
            tab: "py-6 px-2 max-w-40 text-sm font-bold",
            cursor: ["help-center-tabs"],
            tabList: ["max-sm:grid max-sm:grid-cols-2 ml-2"],
          }}
          fullWidth
          variant="light"
          className="justify-between"
        >
          {/* <Tab */}
          {/*   title={ */}
          {/*     <div className="flex items-center space-x-2"> */}
          {/*       <span className="px-20">Help Center List</span> */}
          {/*     </div> */}
          {/*   } */}
          {/* > */}
          {/*   <div className="mt-4 sm:mt-0"> */}
          {/*     <HelpCenterList/> */}
          {/*   </div> */}
          {/* </Tab> */}
          <Tab
            title={
              <div className="flex items-center space-x-2">
                <span className="px-20">Request List</span>
              </div>
            }
          >
            <div className="mt-4 sm:mt-0">
              <RequestList />
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
};

export default HelpCenterTabs;
